<!-- MODAL datosComerciales -->
<div mdbModal #editarComerciales="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">Datos comerciales</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="editarComerciales.hide()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <app-productos-form-datos-comerciales (onSuccess)="onSucessSaveDatosComerciales()"></app-productos-form-datos-comerciales>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                        (click)="editarComerciales.hide()" mdbWavesEffect>Cerrar</button>
                    <button type="submit" class="btn btn-sm btn-secondary waves-light" size="sm" mdbWavesEffect
                    (click)="guardarEditar()"
                    >Guardar</button>
                </div>
            </div>
    </div>
</div>